import { getEnv } from './env';

export type AppEnv = 'development' | 'test' | 'production';

const APP_ENV_VALUES: AppEnv[] = ['development', 'test', 'production'];

const normalizeAppEnv = (value: string): AppEnv | null => {
  const normalized = value.trim().toLowerCase();
  return APP_ENV_VALUES.includes(normalized as AppEnv) ? (normalized as AppEnv) : null;
};

export const getAppEnv = (): AppEnv => normalizeAppEnv(getEnv('VITE_APP_ENV', '')) ?? 'production';

export const isDevelopmentEnv = (): boolean => getAppEnv() === 'development';

export const isTestEnv = (): boolean => getAppEnv() === 'test';

export const isProductionEnv = (): boolean => {
  const appEnv = getAppEnv();
  return appEnv === 'production' || appEnv === 'test';
};

export const getAppEnvLabel = (): string => {
  const appEnv = getAppEnv();
  return appEnv.charAt(0).toUpperCase() + appEnv.slice(1);
};
